module.exports = __webpack_public_path__ + "img/18_60.3e5f61de.png";